import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
  },
  sectionName: {
    width: "300px",
  },
});

export const AddSectionContent = ({
  onSectionNameChange,
  sectionName,
  errors,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <TextField
        className={styles.sectionName}
        value={sectionName}
        onChange={onSectionNameChange}
        variant={"outlined"}
        label={"Section Name"}
        name={"sectionName"}
        error={!!errors["sectionName"]}
        FormHelperTextProps={{
          style: { marginLeft: "0px" },
        }}
        helperText={errors["sectionName"]}
      />
    </View>
  );
};
